import { StyleSheet } from "react-native";

export default StyleSheet.create({
  topHeadPhoto: {
    height: 500,
    width: "100%",
  },
  topHeadPhotoMain: {
    height: 500,
    width: "100%",
  },
  topHeadPhotoBox: {
    // height: 500,
    width: "100%",
  },
  topHeadLower: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    // backgroundColor:'blue',
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    height: 160,
  },
  topHeadNameBox: {

    display: "flex",
    justifyContent: "flex-start",

  },
  penBackgroundCircle: {
    height: 45,
    width: 45,
    backgroundColor: "white",
    borderRadius: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  CircleMainBox: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    // justifyContent:'space-evenly',
    alignItems: "center",
    // width:'45%',
    // backgroundColor:'green'
  },
  MainName: {

    color: "black",
  },
  nameMainBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // justifyContent:'space-between',
    width: "100%",
    gap:5,
    // backgroundColor:'blue'
  },
  linearGradient: {
    flex: 1,
  },
  middleBoxMain: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
  },
  middleImageBox1: {
    borderRadius: 15,
    width: "100%",
  },
  middleImageBox: {
    borderRadius: 15,
    width: "90%",
  },
  middleMainInner: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    // backgroundColor:'blue',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  sparkxImage: {
    height: 35,
    width: 140,
  },
  middleMainText: {
    color: "white",
    fontSize: 16,
    textAlign: "center",
    fontFamily:"InterSemiBold",
    marginTop: 10,
    width: "70%",
  },
  checkoutBox: {
    backgroundColor: "white",
    marginTop: 15,
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderRadius: 30,
  },
  completeProfileMain: {
    width: "90%",
    borderWidth: 0.3,
    borderColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 6,
    height: 220,
    shadowColor: "black",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.06,
    shadowRadius: 5,
    elevation: 10,
    backgroundColor: "white",
  },
  completeProfileOuter: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
  },
  userBox: {
    borderWidth: 2,
    height: 50,
    width: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 30,
  },
  completeProfileText: {
    fontSize: 20,
    color: "black",
    fontWeight: "700",
    marginTop: 10,
  },
  completeAlmost: {
    textAlign: "center",
    width: "90%",
    color: "black",
    fontSize: 15,
    fontWeight: "300",
  },
  editProfileBox: {
    borderWidth: 0.5,
    paddingHorizontal: 24,
    paddingVertical: 10,
    borderRadius: 40,
    marginTop: 10,
  },
  ticketAndHelpMain: {
    width: "100%",
    marginTop: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  ticketBox: {
    display: "flex",
    flexDirection: "row",
    width: "90%",
    justifyContent: "space-between",
    alignItems: "center",
    height: 50,
    borderBottomWidth: 0.5,
    borderBottomColor: "rgba(0, 0, 0, 0.2)",
  },
  ticketText: {
    fontSize: 16,
    color: "black",
    fontWeight: "300",
  },
});
